import { render, staticRenderFns } from "./DestinationCenter.vue?vue&type=template&id=56232ca8"
import script from "./DestinationCenter.vue?vue&type=script&lang=js"
export * from "./DestinationCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports